/**
* @copyright Copyright (c) MITSUBISHI Electric Corporation. All rights reserved.
*/

import * as CommonHttp from "./commonHttp"
import { getPegadaBaseUrl } from "./baseUrl"

let baseUrl = getPegadaBaseUrl()

let getAccountInfoUrl = `${baseUrl}/v1/accounts/login/get`
let accountListUrl = `${baseUrl}/v1/accounts/tenant/list?tenant_id=__ID`
let updateAccountUrl = `${baseUrl}/v1/accounts/update`
let deleteAccountUrl = `${baseUrl}/v1/accounts/delete`
let createAccountUrl = `${baseUrl}/v1/accounts/regist`

export async function getAccountInfo(session) {
    try {
        let token = (typeof session === 'string' || session instanceof String) ? session : await CommonHttp.getJwtToken(session)
        let headers = {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: token
        }
        return await CommonHttp.send(getAccountInfoUrl, CommonHttp.GET, headers)
    } catch (e) {
        throw e
    }
}

export async function getAccountList(orgId, session) {
    try {
        let token = (typeof session === 'string' || session instanceof String) ? session : await CommonHttp.getJwtToken(session)
        let headers = {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: token
        }

        let url = accountListUrl.replace("__ID", orgId)

        return await CommonHttp.send(url, CommonHttp.GET, headers)
    } catch (e) {
        throw e
    }
}

export async function updateAccount(session, body) {
    try {
        let token = (typeof session === 'string' || session instanceof String) ? session : await CommonHttp.getJwtToken(session)
        let headers = {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: token
        }

        return await CommonHttp.send(updateAccountUrl, CommonHttp.POST, headers, body)
    } catch (e) {
        throw e
    }
}

export async function deleteAccount(session, body) {
    try {
        let token = (typeof session === 'string' || session instanceof String) ? session : await CommonHttp.getJwtToken(session)
        let headers = {
            Authorization: token
        }

        return await CommonHttp.send(deleteAccountUrl, CommonHttp.POST, headers, body)
    } catch (e) {
        throw e
    }
}

export async function createAccount(session, body) {
    try {
        let token = (typeof session === 'string' || session instanceof String) ? session : await CommonHttp.getJwtToken(session)
        let headers = {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: token
        }

        return await CommonHttp.send(createAccountUrl, CommonHttp.POST, headers, body)
    } catch (e) {
        throw e
    }
}